import React from 'react'

const Footer = () => {
  return (
    <div>
      {/* <!--start footer --> */}
      <footer class="footer-a">
        <div class="footer-fist-row pt40">
          <div class="container">
            <div class="row footer-deg2">
              <div class="col-5s">
                <div class="footer-ree-c">
                  <div class="footer-logo">
                    <h5 style={{ cursor: "default" }}>
                      {/* <a href="#" style={{    color: "#adb7c5" }}> */}{" "}
                      {/* <img
                        src="images/footer-logo.png"
                        alt="reeven"
                        class="img"
                      />{" "} */}
                      Mount Saffron Technologies and consultant Pvt. Ltd.
                      {/* </a>  */}
                    </h5>
                  </div>
                  <p class="">
                    Empowering businesses with cutting-edge IT solutions, we
                    help you drive success through technology, leveraging our
                    expertise to deliver impactful results in just over a year
                  </p>

                  <ul class="footer_social mt30">
                    {/* <li>
                      <a href="https://x.com/softapproachit" target="_blank">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-twitter-x" viewBox="0 0 16 16">
                          <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z" />
                        </svg>
                      </a>
                    </li> */}
                    {/* <li>
                      {" "}
                      <a href="https://www.facebook.com/people/Sanwar-Ranwa/61571617390290/" target="_blank">
                        <i class="fab fa-facebook-f" aria-hidden="true"></i>
                      </a>
                    </li>
                    <li>
                      <a href="https://www.youtube.com/@SoftApproachIT" target="_blank">
                        <i class="fab fa-youtube" aria-hidden="true"></i>
                      </a>
                    </li> */}
                    <li>
                      <a href="https://www.linkedin.com/company/mount-saffron-technologies-and-consultant-pvt-ltd/posts/?feedView=all" target="_blank">
                        <i class="fab fa-linkedin-in" aria-hidden="true"></i>
                      </a>
                    </li>
                    {/* <li>
                      {" "}
                      <a href="https://www.instagram.com/softapproachit/profilecard/" target="_blank">
                        <i class="fab fa-instagram" aria-hidden="true"></i>
                      </a>{" "}
                    </li> */}
                  </ul>

                  {/* <a
                    href="/MSIT-NewUpdateBooklet.pdf"
                    class="ree-btn  ree-btn-grdt1 mw-80 no-shadows mt40"
                    download
                  >
                    Our Brochure <i class="fas fa-arrow-right fa-btn"></i>
                  </a> */}
                </div>
              </div>
              <div class="col-5s">
                <h5>For Work inquiry</h5>
                <ul class="footer-links-list social-linkz">
                  <li>
                    <a href="tel:9024821468">
                      <span>
                        <i class="fas fa-phone-square-alt"></i>
                      </span>{" "}
                      9024821468
                    </a>
                  </li>
                  <li>
                    <a href="https://wa.me/9024821468"
                      target="_blank">
                      <span>
                        <i class="fab fa-whatsapp-square"></i>
                      </span>{" "}
                      9024821468
                    </a>
                  </li>

                  <li>
                    <a href="mailto:career@mount saffron.com">
                      <span>
                        <i class="fas fa-envelope"></i>
                      </span>{" "}
                      hr@mountsaffronit.com
                    </a>
                  </li>
                </ul>
              </div>
              <div class="col-5s">
                <h5>Company</h5>
                <ul class="footer-links-list">
                  <li>
                    <a href="#about"> About us</a>
                  </li>
                  <li>
                    <a href="#service">Services</a>
                  </li>
                  <li>
                    <a href="#blog">Approach</a>
                  </li>
                  <li>
                    <a href="#work">Our Projects</a>
                  </li>
                  <li>
                    <a href="#product">Our Products</a>
                  </li>
                  {/* <li>
                    <a href="/privacy-policy">Privacy & Policy</a>
                  </li> */}
                </ul>
              </div>
              <div class="col-5s">
                <h5>Services</h5>
                <ul class="footer-links-list">
                  {/* <li>
                    <a href="/hire-dedicated-developers">Hire Dedicated Developers</a>
                  </li> */}
                  <li>
                    <a href="#service">Web App Development</a>
                  </li>
                  <li>
                    <a href="#service">Mobile App Development</a>
                  </li>
                  {/* <li>
                    <a href="/search-engine-ptimization">Search Engine Optimization</a>
                  </li> */}
                  <li>
                    <a href="#service">Hybrid App Development</a>
                  </li>
                  <li>
                    <a href="#service">UI/UX Designing</a>
                  </li>
                </ul>
              </div>
             <div class="col-5s">
  <h5>Our Products</h5>
  <ul class="footer-links-list">

    <li><strong>School ERP</strong></li>
    <li>
      <a href="https://violetsync.com/" target="_blank">VioletSync</a>
    </li>

    <li><strong>LMS Platforms</strong></li>
    <li>
      <a href="https://www.softapproachit.com/" target="_blank">SoftApproachIT</a>
    </li>
    <li>
      <a href="https://www.codejido.com/" target="_blank">CodeJido</a>
    </li>

  </ul>
</div>
            </div>
          </div>

          <div class="container ft-cpy bt-top mt70">
  <div class="row justify-content-center text-center">
    <div class="col-lg-12">
      <div class="ft-copyright">
        <p>
          © 2026 MOUNT SAFFRON TECHNOLOGIES AND CONSULTANT PRIVATE LIMITED. All rights reserved.
        </p>
      </div>
    </div>
  </div>
</div>
        </div>
      </footer>
      {/* <!-- end footer --> */}
    </div>
  )
}

export default Footer
